import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import HeroSection from '@/components/HeroSection';
import ScrollContent from '@/components/ScrollContent';
import Footer from '@/components/Footer';
import Conversations from '@/components/Conversations';
import Episode01 from '@/components/Episode01';
import Episode02 from '@/components/Episode02';
import Episode03 from '@/components/Episode03';
import Episode04 from '@/components/Episode04';
import Writing from '@/components/Writing';
import ArticlePage from '@/components/ArticlePage';

function MainPage() {
  return (
    <div className="site-wrapper">
      <HeroSection />
      <ScrollContent />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <div className="film-grain" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/episodes" element={<Conversations />} />
          <Route path="/episodes/episode-01" element={<Episode01 />} />
          <Route path="/episodes/episode-02" element={<Episode02 />} />
          <Route path="/episodes/episode-03" element={<Episode03 />} />
          <Route path="/episodes/episode-04" element={<Episode04 />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/writing/:slug" element={<ArticlePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
